import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import DatePicker, { registerLocale } from "react-datepicker";
import { zhTW, zhCN, enUS } from 'date-fns/locale';

import "react-datepicker/dist/react-datepicker.css";

const BirthdayCalendar = (props) => {
	const { t, i18n } = useTranslation();

	const {form_component} = props;
	const {required} = form_component;

	const fv = useSelector(state => state.fv);
	const pageData = useSelector(state => state.pageData);
	const controller = pageData.controller;
	const userData = useSelector(state => state.userData);

	const yearStart = useMemo(() => {
		const n = parseInt(form_component.year_select_start, 10);
		return Number.isNaN(n) ? 1950 : n;
	}, [form_component.year_select_start]);
	const yearEnd = useMemo(() => {
		const n = parseInt(form_component.year_select_end, 10);
		return Number.isNaN(n) ? new Date().getFullYear() : n;
	}, [form_component.year_select_end]);
	const minDate = useMemo(() => new Date(Math.min(yearStart, yearEnd), 0, 1), [yearStart, yearEnd]);
	const maxDate = useMemo(() => new Date(Math.max(yearStart, yearEnd), 11, 31), [yearStart, yearEnd]);

	const [date, setDate] = useState(() => {
		const birthday = userData && userData.birthday;
		if (birthday && birthday.year && birthday.month && birthday.day) {
			return new Date(birthday.year, birthday.month - 1, birthday.day);
		}
		return null;
	});

	const yearRef = useRef(null);
	const monthRef = useRef(null);
	const dayRef = useRef(null);

	const updateHiddenFields = (value) => {
		if (yearRef.current) {
			yearRef.current.value = value ? value.getFullYear() : '';
		}
		if (monthRef.current) {
			monthRef.current.value = value ? value.getMonth() + 1 : '';
		}
		if (dayRef.current) {
			dayRef.current.value = value ? value.getDate() : '';
		}
	};

	const registerField = () => {
		const validator = controller === 'Shopcarts' ? window.globalFormValidator : fv;

		if (validator && required) {
			const fieldName = 'birthday[year]';

			try {
				if (validator.elements && validator.elements[fieldName]) {
					validator.removeField(fieldName);
				}

				validator.addField(fieldName, {
					validators: {
						notEmpty: {
							message: t('此欄為必須填寫')
						}
					},
					selector: `input[name="${fieldName}"]`
				});
			} catch (error) {
				console.error('Error registering field:', fieldName, error);
			}
		}
	};

	useEffect(() => {
		registerField();
	}, [fv, controller, required, t]);

	useEffect(() => {
		const handleReinitialization = () => {
			registerField();
		};

		document.addEventListener('formValidationReinitialized', handleReinitialization);

		return () => {
			document.removeEventListener('formValidationReinitialized', handleReinitialization);
		};
	}, [fv, controller, required, t]);

	const locales = { zhTW, zhCN, enUS };
	Object.entries(locales).forEach(([key, value]) => registerLocale(key, value));

	const onChange = (value) => {
		setDate(value);
		updateHiddenFields(value);
	};

	const defaultYear = userData && userData.birthday ? userData.birthday.year : '';
	const defaultMonth = userData && userData.birthday ? userData.birthday.month : '';
	const defaultDay = userData && userData.birthday ? userData.birthday.day : '';

	return (
		<>
			<input type="hidden" name="birthday[year]" ref={yearRef} defaultValue={defaultYear} />
			<input type="hidden" name="birthday[month]" ref={monthRef} defaultValue={defaultMonth} />
			<input type="hidden" name="birthday[day]" ref={dayRef} defaultValue={defaultDay} />
			<DatePicker
				className="form-control form-control-sm"
				showIcon
				dateFormat="yyyy-MM-dd"
				showMonthDropdown
				showYearDropdown
				selected={date}
				onChange={onChange}
				minDate={minDate}
				maxDate={maxDate}
				locale={i18n.language.replace('-', '')}
				placeholderText={t('請選擇日期')}
			/>
		</>
	);
}

export default BirthdayCalendar;
